import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';

const RegisterForm: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    try {
      await axiosInstance.post('/api/auth/register', { username, email, password });
      alert('회원가입이 완료되었습니다. 로그인 페이지로 이동합니다.');
      navigate('/login');
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.error) {
        setMessage(err.response.data.error);
      } else {
        setMessage('회원가입에 실패했습니다. 다시 시도해 주세요.');
      }
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '60px auto', padding: '36px', background: 'var(--surface)', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-md)' }}>
      <h2 style={{ fontSize: 26, fontWeight: 800, textAlign: 'center', marginBottom: 24, letterSpacing: '-0.5px' }}>
        ✨ 역사 아카이브 회원가입
      </h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label className="form-label">아이디</label>
          <input 
            type="text"
            value={username} 
            onChange={e => setUsername(e.target.value)} 
            placeholder="사용하실 아이디를 입력하세요" 
            required 
            className="modern-input"
          />
        </div>
        
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label className="form-label">이메일 주소</label>
          <input 
            type="email"
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            placeholder="이메일 주소를 입력하세요" 
            required 
            className="modern-input"
          />
        </div>
        
        <div className="form-group" style={{ marginBottom: 24 }}>
          <label className="form-label">비밀번호</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword ? 'text' : 'password'} 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              placeholder="안전한 비밀번호를 입력하세요" 
              required 
              className="modern-input"
              style={{ paddingRight: '40px' }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                color: 'var(--text-secondary, #666)'
              }}
              aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
            >
              {showPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
        </div>
        
        <button type="submit" className="modern-btn modern-btn-primary" style={{ width: '100%', padding: '12px' }}>
          회원 등록 완료
        </button>
        
        {message && (
          <div style={{ 
            color: 'var(--danger)', 
            backgroundColor: 'var(--danger-light)', 
            padding: '10px 14px', 
            borderRadius: 'var(--radius-sm)', 
            fontSize: 13, 
            fontWeight: 600,
            marginTop: 16,
            textAlign: 'center'
          }}>
            ⚠️ {message}
          </div>
        )}
      </form>
      
      <div style={{ marginTop: 24, textAlign: 'center', fontSize: 13.5, color: 'var(--text-secondary)' }}>
        이미 계정이 있으신가요?{' '}
        <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 700, textDecoration: 'underline' }}>
          로그인 하기
        </Link>
      </div>
    </div>
  );
};

export default RegisterForm;
